<template>
  <v-container
    fluid
    cols="12"
    class="d-flex grey lighten-2 account-detail"
  >
    <v-card class="ma-2 pa-6">
      <v-card-title class="toolbar success white--text subheading">
        <div>
          User:
          <UserChip
            v-if="!!userId"
            :id="userId"
          />
        </div>
        <div
          v-if="snr"
          class="pl-5"
        >
          Account:
          <AccountChip
            :snr="snr"
          />
        </div>
      </v-card-title>
      <v-card-text>
        <v-layout
          wrap
          class="pa-0 "
        >
          <v-flex
            v-for="field in cleanFields(item)"
            :key="field"
            class="pa-2"
          >
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <span
                  v-on="on"
                >
                  <v-text-field
                    :label="formatFieldName(field, item)"
                    :value="formatValue(item[field], field)"
                    readonly
                    class="body-1"
                    :class="field"
                  />
                </span>
              </template>
              <span>
                field: {{ field }}
              </span>
            </v-tooltip>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import _ from 'lodash';
import UserChip from '@/components/shared/user/UserChip';
import AccountChip from '@/components/baader/shared/AccountChip';

export default {
  name: 'BaaderRowDetail',
  components: {
    UserChip,
    AccountChip,
  },
  props: {
    item: {
      type: Object,
      default: () => [],
    },
    userId: {
      type: Number,
      default: null,
      required: true,
    },
    snr: {
      type: String,
      default: null,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    formatDate(date) {
      return this.$moment(date).format('MMMM Do YYYY, h:mm:ss a');
    },

    centsToEuros(amount) {
      amount = `${parseInt(amount, 0) / 100}`;

      return `${parseFloat(amount).toFixed(2)} €`;
    },


    /**
     * removes keys from object if value is falsy or typeof object
     */
    cleanFields(data) {
      return Object.keys(data)
        .filter(field => !!data[field] && typeof data[field] !== 'object');
    },

    formatFieldName(str, item) {
      const camelCaseSentence = str.replace(/([-_]\w)/g, g => g[1].toUpperCase());
      const sentence = _.startCase(camelCaseSentence);

      if (item) {
        if (str === 'security_wallet' && item.sell_offer.asset.provider === 'baaderbank') {
          return `${_.capitalize(sentence)} / Baader Bank account`;
        }
      }

      return _.capitalize(sentence);
    },

    formatValue(value, key) {
      if (key === 'total' || key === 'unit_price') {
        return this.centsToEuros(value);
      }
      if (key.includes('_at')) {
        return this.formatDate(value);
      }

      return value;
    },
  },
};
</script>

<style lang="scss" scoped>
.account-detail{

}
</style>



// WEBPACK FOOTER //
// src/components/baader/shared/BaaderRowDetail.vue